import { GetContractsResponseSchema, type GetContractsResponse } from '@vy/api-definition';
import { isNotNullOrUndefined, validateNotEmptyObject } from '@vy/utils';
import { useQuery } from 'react-query';
import { getPrivateApi } from '../../services/api';
import type { CustomUseQueryOptions } from './requests-types/custom-use-query-options';
import { queryKeys } from '../../services/query-key/query-keys';

export function useContractsByCustomerId(
  customerId: string,
  pagination?: { page: number; pageSize: number },
  options?: CustomUseQueryOptions<GetContractsResponse>,
) {
  const paginationParams = isNotNullOrUndefined(pagination)
    ? { page: pagination.page, pageSize: pagination.pageSize }
    : undefined;

  const data = useQuery({
    queryKey: queryKeys.contracts(
      customerId,
      ...(isNotNullOrUndefined(paginationParams) ? Object.values(paginationParams) : []),
    ),
    suspense: true,
    ...options,
    queryFn: async () => {
      const api = getPrivateApi();
      const getContractsResponse = await api.getContracts({
        customerId,
        ...(isNotNullOrUndefined(pagination) && { page: pagination.page, pageSize: pagination.pageSize }),
      });

      return GetContractsResponseSchema.parse(getContractsResponse);
    },
  });

  validateNotEmptyObject(data, `Contracts with customer id ${customerId}`);

  return data;
}
